<template>
  <div class="intro-item">
    <div class="item-wrap">
      <img class="item-icon" :src="icon" />
      <div class="item-label" v-html="label" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'intro-item',

    props: ['icon', 'label']
  }
</script>

<style lang="scss" scoped>
  .intro-item {
    padding: 4px 0;

    .item-wrap {
      width: 100%;
      height: 40px;
      border-radius: 4px;
      background: #f6faff;
      padding: 0 12px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .item-icon {
      width: 32px;
      height: 32px;
    }

    .item-label {
      flex: 1;
      padding-left: 8px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: #333333;

      ::v-deep span {
        color: #ff6e08;
      }
    }
  }
</style>
